/* eslint-disable no-underscore-dangle */
import { useEffect } from "react";
import * as Scrivito from "scrivito";

export function useMatomoPageTracking(currPageId, trackingAllowed) {
  useEffect(() => {
    if (Scrivito.isEditorLoggedIn()) return;
    if (!window._paq || !trackingAllowed) return;

    window._paq.push(["setCustomUrl", window.location.href]);
    window._paq.push(["setDocumentTitle", document.title]);
    window._paq.push(["trackPageView"]);
  }, [currPageId, trackingAllowed]);
}
